<template>    
        <router-link v-if="categoryData.length > 0 " class="recipe-item--little" 
                :to="{ name:'RecipeDetails_' + currentLangName(), params: {recipe_slug: recipe_slug, recipes_category_slug: categoryData[0].slug}}" @click.native="GTMProdCatClick(name)">           
            <div class="recipe-item__img-wrap">
                <img v-if="src!='no-image'"  
                    :srcset="srcset" 
                    :alt="name" 
                    :title="name" 
                    class="img-fluid recipe-item__img"                     
                    sizes="(max-width: 767px) 740px, 370px" 
                    :src="src_url + '/' + src" 
                />
                <img v-else
                    src='@/assets/images/noimage/recept-no-image.svg' 
                    :alt="name" 
                    :title="name" 
                    class="img-fluid recipe-item__img"
                 />
                <div class="recipe-item__category-name" v-if="categoryData.length > 0">                    
                    <span v-for="categoryName in categoryData" :key="categoryName.id">
                        {{ categoryName.name }}
                    </span>
                </div>              
            </div> 
            <div class="recipe-item__text">
                <div class="recipe-item__name">{{  name }}</div>  
                <div class="recipe-item__btn-wrap">       
                    <div  class=" text-link text-link--next" >{{ lang('recept_elolvasom')}}</div>
                </div>                         
            </div>
        </router-link>        
</template>

<script>


export default {
    data(){
        return {
            categoryId: [],
            src_url: process.env.VUE_APP_BIFROST_API_URL_NO_PROJECTNAME
        }
    },   
    props: ['name', 'id', 'recipe_slug', 'srcset', 'src', 'difficulty', 'dish', 'making_time'],
    computed:{                      
        categoryData(){             
            let categoryArray = this.$store.getters.getRecipesCategory;                   
            return this.getCategoryData(this.id, categoryArray  )
        }        
    },
    methods:{
        GTMProdCatClick(recipe){          
            this.setDataLayer('recipe_details', recipe, '')                  
        }
    },
    created(){
        
    }
}
</script>